import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getSportsContentConfigs() {
    return {
        palette: {
            [PALETTE_IDS.EVENT_LIST]: {
                EVENT_LIST_ITEM_TIMING_STATUS: {
                    EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND3,
                },
                EVENT_LIST_ITEM_MORE_MARKETS_BUTTON_TEXT: COLOR.BRAND.FOREGROUND1,
                EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND3,
                EVENT_LIST_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_SECOND,
                    fontSize: FONT.SIZE_XSMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'capitalize',
                },
                EVENT_LIST_HEADER_WITH_SEPARATOR: false,
                EVENT_LIST_MOBILE_HEADER_WITH_SEPARATOR: false,

                EVENT_LIST_GROUP_MARKET_TEXT: {
                    fontSize: FONT.SIZE_SMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                EVENT_LIST_GROUP_NAME_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
            },
            [PALETTE_IDS.PROMOTION_QUICK_LINKS]: {
                PROMOTION_QUICK_LINK_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND5,
                },
            },
            [PALETTE_IDS.EVENT_PAGE]: {
                MARKETS_GROUPS_SELECTOR_BUTTON: {
                    TOGGLE_BUTTON_TEXT: {
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND1,
                },
                EVENT_PAGE_VISUALISATION_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
                EVENT_PAGE_VISUALISATION_SELECTOR: {
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND4,
                },
            },
            [PALETTE_IDS.SPORTS_CONTENT]: {
                SPORT_TABS_PIVOT: {
                    PIVOT_ROW_BG: COLOR.BRAND.BACKGROUND1,
                },
            },
            [PALETTE_IDS.SPORT_PAGE]: {
                SPORT_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                SPORT_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND6,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontSize: FONT.SIZE_LARGE,
                },

                LEAGUES_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.BACKGROUND7,
                    fontFamily: FONT.FAMILY_SECOND,
                    fontSize: FONT.SIZE_XSMALL,
                    textTransform: 'capitalize',
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                LEAGUES_CONTAINER_BORDER_RADIUS: 8,
                LEAGUES_HEADER_BG: COLOR.RESERVED.TRANSPARENT,
                LEAGUES_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                LEAGUES_ITEM_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },

                EVENT_LIST_SKELETON: {
                    EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                    EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.FOREGROUND7,
                },
            },
            [PALETTE_IDS.EVENTS_COUPON]: {
                EVENTS_COUPON_EVENT_LIST: {
                    EVENT_LIST_ALL_EVENTS_LINK: {
                        SECONDARY_LINK_TEXT: COLOR.BRAND.ACCENT3,
                    },
                },
            },
            [PALETTE_IDS.COUPONS]: {
                COUPONS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_SECOND,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'capitalize',
                },

                MATCHES_FILTER_BUTTON_SKELETON: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND5,
                },

                PRICE_BOOST_COUPON_EVENT_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                PRICE_BOOST_COUPON_ITEM: {
                    PBI_SELECTION_NAME_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_BOLD,
                    },
                },
            },
            [PALETTE_IDS.HOME_PAGE]: {
                HOME_PAGE_TOP_SPORTS_ROW_ICON_COLOR: COLOR.BRAND.ACCENT1,
            },
        },
    };
}
